module.exports = __webpack_public_path__ + "img/logo.246a1681.png";